// removed by extract-text-webpack-plugin
module.exports = {"tileOuterMostContainer":"tileOuterMostContainer__2PIKz","tileContainer":"tileContainer__odXTD","tileHeaderContainer":"tileHeaderContainer__faCLK","tileHeaderOuterContainer":"tileHeaderOuterContainer__2CoLB","titleHeaderInnerContainer":"titleHeaderInnerContainer__2eBhI","titleLogo":"titleLogo__1171s","titleText":"titleText__2KAOF","subtitleText":"subtitleText__3wCxh","seeMore":"seeMore__394dR","arrowsContainer":"arrowsContainer__n7wHu","arrow":"arrow__2UcVY","widthHandler":"widthHandler__1I_Jk"};


//////////////////
// WEBPACK FOOTER
// ./componentsBICRevamp/buyWithInstacredLanding/tilesContainer/style.css
// module id = 68/9
// module chunks = 323